import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {FormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';

import {TabsModule} from '../../components/tabs/tabs.module';
import {CommonComponentsModule} from '../../common-components.module';

import {DatetimeModule} from '../../components/datetime/datetime.module';
import {FieldsModule} from '../../components/fields/fields.module';
import {AngularMaterialImportModule} from '../../components/angular-material-import-module/angular-material-import.module';
import {AngularMultiSelectModule} from '../../components/angular2-multiselect-dropdown/multiselect.component';
import {SafeHtmlPipeModule} from '../../pipes/safe-html/safe-html-pipe.module';
import {SettingsIntegrationsComponent} from './settings-integrations.component';
import {SettingsIntegrationsListComponent} from './settings-integrations-list/settings-integrations-list.component';
import {SettingsIntegrationsDetailedViewComponent} from './settings-integrations-detailed-view/settings-integrations-detailed-view.component';
import {SettingsIntegrationsFilterComponent} from '../../components/settings-integrations-filter/settings-integrations-filter.component';
import {SettingsIntegrationsService} from '../../services/settings-integrations.service';
import {SettingsIntegrationsAppsListComponent} from './settings-integrations-apps-list/settings-integrations-apps-list.component';
import {SettingsIntegrationsCategoryFilterComponent} from '../../components/settings-integrations-category-filter/settings-integrations-category-filter.component';


@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        TabsModule,
        RouterModule,
        CommonComponentsModule,
        DatetimeModule,
        FieldsModule,
        AngularMaterialImportModule,
        AngularMultiSelectModule,
        SafeHtmlPipeModule
    ],
    declarations: [
        SettingsIntegrationsComponent,
        SettingsIntegrationsListComponent,
        SettingsIntegrationsDetailedViewComponent,
        SettingsIntegrationsFilterComponent,
        SettingsIntegrationsAppsListComponent,
        SettingsIntegrationsCategoryFilterComponent
    ],
    providers: [
        SettingsIntegrationsService
    ]
})
export class SettingsIntegrationsModule {
}




// WEBPACK FOOTER //
// /app/src/app/views/settings-integrations/settings-integrations.module.ts